import { getRecommendedIdFromLocationSearch } from '../data/compareScreensV2Models';

const KEY_SELECTED = 'compareScreensV2.selectedIds';
const KEY_CHOOSE = 'compareScreensV2.choose';

/**
 * Restore compare selection: sessionStorage plus optional ?recommended= merge (max 3).
 */
export function loadCompareSelectedIds(searchString, validIds) {
  const valid = new Set(validIds);
  const urlId = getRecommendedIdFromLocationSearch(searchString);
  let ids = [];
  try {
    const raw = sessionStorage.getItem(KEY_SELECTED);
    if (raw) ids = JSON.parse(raw);
  } catch {
    ids = [];
  }
  if (!Array.isArray(ids)) ids = [];
  ids = ids.filter((id) => valid.has(id));
  if (urlId) {
    const rest = ids.filter((id) => id !== urlId);
    ids = [urlId, ...rest].slice(0, 3);
  }
  return ids;
}

export function persistCompareSelectedIds(ids) {
  try {
    sessionStorage.setItem(KEY_SELECTED, JSON.stringify(ids));
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadChooseAnswers() {
  try {
    const raw = sessionStorage.getItem(KEY_CHOOSE);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (
      o &&
      typeof o === 'object' &&
      o.where != null &&
      o.priority != null &&
      o.size != null
    ) {
      return { where: o.where, priority: o.priority, size: o.size };
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function persistChooseAnswers(state) {
  try {
    sessionStorage.setItem(KEY_CHOOSE, JSON.stringify(state));
  } catch {
    /* ignore */
  }
}
